import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/es5/util/colors'
// import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    iconfont: "mdi",
  },

  theme: {
    dark: true,
    options: { 
      customProperties: true 
    },
    themes: {
      light: {
        accent: colors.shades.black,
        background: colors.purple.lighten1,
        error: colors.red.accent3,
        primary: colors.purple.lighten2,
        secondary: colors.grey.darken1,
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        accent: colors.yellow,
        background: colors.purple.darken4,
        error: colors.red,
        info: colors.yellow,
        menu: colors.purple.darken2,
        primary: colors.purple.darken2,
        secondary: colors.black,
        success: colors.green,
        warning: colors.yellow,
      }
    },
  },
})

export default vuetify
